export default __webpack_public_path__ + "static/optymalizacja-f09a753b739484b21d4e0f160e2df682.jpeg";